import { render, staticRenderFns } from "./ProductReferral.vue?vue&type=template&id=06954d04"
import script from "./ProductReferral.vue?vue&type=script&lang=js"
export * from "./ProductReferral.vue?vue&type=script&lang=js"
import style0 from "./ProductReferral.vue?vue&type=style&index=0&id=06954d04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports